<div class="banner" role="status" data-testid="support-banner">
  <ui-inline-svg class="banner-icon" name="shield"></ui-inline-svg>
  <span class="banner-title">{{ 'SUPPORT_MODE.TITLE' | transloco }}</span>
</div>
